import { useApiCall } from "@jane/lib/src/api";
import { Input } from "@jane/lib/src/components/form/Input";
import {FC, useState} from "react";
import {config} from "../config";
import {BuddyTeam} from "../../../lib/src/api/repositories/buddy-teams-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditBuddyTeamModal: FC<{team: BuddyTeam, onFinished: () => void}> = (props) => {
  const {buddyTeams} = useApiCall(config)
  const [email, setEmail] = useState(props.team.email ?? '')
  const [telephone, setTelephone] = useState(
    props.team.external_telephone ?? ""
  );
  const save = async () => {
    await buddyTeams.addOrUpdate(props.team.target, props.team.enabled, null, email, telephone)
    props.onFinished()
  }
  return <div className={"flex flex-col space-y-3"}>
    <Input type={'email'} label={'Email'} value={email} onChange={setEmail} />
    <Input type={'text'} label={'Extern telefoonnummer'} placeholder={'08001234567'} value={telephone} onChange={setTelephone} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}